export enum ImpairedInformationRoutes {
  Documents = 'documents',
  AboutThePortal = 'aboutThePortal',
  TermOfUse = 'termOfUse'
}
